import { css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { watch } from "../internal/watch";
import { IModerationRequest } from "../../backend/cloud/ModerationTable";

import "../Diff/PlaceDiff";
import { UserTable } from "../../backend/cloud/UserTable";
import { ifDefined } from "lit/directives/if-defined.js";

@customElement("ds-moderation-request")
export class ModerationRequest extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            sl-avatar {
                --size: 2em;
            }
        `,
    ];
    @property({ type: String }) requestId?: string;
    @state() protected _request?: IModerationRequest;
    @state() protected _userAvatarUrl?: string;
    @state() protected _displayName?: string;

    private _moderationTable = this._kernel.dataStore.getSource("moderation-requests");
    private _userTable = this._kernel.dataStore.getSource<UserTable>("users");

    @watch("requestId")
    async onRequestIdChanged() {
        this._userAvatarUrl = this._request = undefined;
        this._displayName = undefined;
        if (this.requestId) {
            this._request = await this._moderationTable.read(this.requestId);
            if (this._request) {
                const owner = await this._kernel.userSettings.read(this._request.owner);
                if (owner) {
                    this._userAvatarUrl = await this._kernel.userSettings.getAvatarURL(owner);
                    this._displayName = owner?.displayName ?? undefined;
                }
            }
        }
    }

    override render() {
        if (this._request) {
            return html`<div class="container">
                <sl-card class="card-header">
                    <div slot="header">
                        <div class="flex-column">
                            <div class="user-name">
                                <sl-avatar image=${ifDefined(this._userAvatarUrl)}></sl-avatar>
                                <span>Submitted by ${this._displayName}</span>
                            </div>
                            <small slot="footer" class="date-time"
                                >${new Date(this._request.createdAt).toString()}</small
                            >
                        </div>
                    </div>
                    <ds-place-diff .request=${this._request}></ds-place-diff>
                </sl-card>
            </div>`;
        }

        return html``;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-moderation-request": ModerationRequest;
    }
}
